import SkapaTable, {
  TableBody as SkapaTableBody,
  TableHeader as SkapaTableHeader,
  type TableBodyProps,
  type TableHeaderProps,
  type TableProps,
} from "@ingka/table";

export type { TableProps, TableHeaderProps, TableBodyProps };

export const Table = (props: TableProps) => {
  return <SkapaTable prefix="saleslead__" {...props} />;
};

export const TableHeader = (props: TableHeaderProps) => {
  return <SkapaTableHeader prefix="saleslead__" {...props} />;
};

export const TableBody = (props: TableBodyProps) => {
  return <SkapaTableBody prefix="saleslead__" {...props} />;
};
